import React from "react";
import _get from "lodash/get";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CircularProgress from "@mui/material/CircularProgress";
import UserAddEditForm from "./Forms/UserAddEdit";
import SmsForm from "./Forms/SmsForm";
import {
  getUsers,
  getUserCount,
  selectedUser,
  getScopes,
  updateUserScope,
} from "../../../actions/userActions";
import ReduxButton from "../../../components/ReduxButton";
import SearchInput from "../../../components/SearchInput";
import UserTable from "./UserTable";
import { formatDate } from "../../../actions/momentActions";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import SearchIcon from "@mui/icons-material/Search";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { LABELS as _LABELS } from "../../../language";

const LABELS = _LABELS.settingPage;

const styles = (theme) => ({
  addButtonWrapper: {
    width: "99%",
    textAlign: "right",
    marginTop: 10,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100px",
    textAlign: "left",
  },
  grow: {
    flexGrow: 1,
    // textAlign: "center",
    float: "left",
    marginTop: "10px",
    marginBottom: "10px",
  },
  loader: {
    flexGrow: 1,
    textAlign: "center",
    marginTop: "20px",
  },
});

export class User extends React.Component {
  state = {
    open: false,
    selTab: 0,
    page: 0,
    limit: 10,
    searching: false,
    showAll: false,
    query: "",
  };

  async componentDidMount() {
    await this.getUsers();
    await this.getUserCount();
    await this.getScopes();
  }

  getUserCount = async () => {
    await this.props.getUserCount();
  };

  getScopes = async () => {
    const scopes = await this.props.getScopes();
    this.setState({ scopes });
  };

  getUsers = async () => {
    const { page, limit, query, showAll } = this.state;
    const skip = parseInt(page) * parseInt(limit);
    const payload = {
      limit,
      skip,
      query,
    };
    if (!showAll) {
      payload.status = "ACTIVE";
    }

    this.setState({ searching: true });
    await this.props.getUsers(payload);
    this.setState({ searching: false });
  };

  handleClose = async () => {
    this.setState({ isAdd: false, selected: null });
    await this.getUserCount();
    await this.getUsers();
  };

  handleAddClose = async () => {
    this.setState({ isAdd: false, selected: null }, async () => {
      await this.getUserCount();
      await this.getUsers();
    });
  };

  handleEdit = (selected) => {
    this.props.selectedUser(selected);
    this.setState({ isAdd: true, isEdit: true, selected });
  };

  handleSms = (selected) => {
    this.setState({ openSms: true, selected });
  };

  handleChange = ({ limit, page, order }) => {
    this.setState({ limit, page, order, query: "" }, this.getUsers);
  };

  onSearch = (query) => {
    const { page, limit, order, selTab } = this.state;
    if (query.trim() === "") {
      // If query is empty, reset it to empty string and trigger search for all items
      this.setState({ limit, page, order, query: "" }, () => {
        if (selTab === 0) {
          this.getUsers();
        }
      });
    } else {
      // If there's a query, perform search as usual
      if (selTab === 0) {
        this.setState({ limit, page, order, query }, this.getUsers);
      }
    }
  };

  viewDetails = (driver) => {
    const { accountBaseUrl } = this.props;
    this.props.history.push(
      `${accountBaseUrl}/settings/user/${driver.driverId}`
    );
  };

  switchChange = () => {
    const { showAll } = this.state;
    this.setState({ showAll: !showAll }, () => {
      this.getUsers();
    });
  };
  render() {
    const { classes, userBusy, isViewOnly } = this.props;
    const { selected, showAll } = this.state;

    return (
      <div>
        <AppBar position="static" color="default">
          <Toolbar>
            <div className={classes.grow}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showAll}
                    onChange={this.switchChange}
                    name="checkedB"
                    color="primary"
                  />
                }
                label={LABELS.showall}
              />
            </div>
            <div style={{ float: "right" }}>
              <FormControl>
                <TextField
                  style={{ width: "15rem", marginRight: "2rem" }}
                  size="small"
                  variant="outlined"
                  placeholder={LABELS.search}
                  onChange={(e) => this.onSearch(e.target.value)} // Modified to pass value directly
                  value={this.query}
                />
              </FormControl>
            </div>
          </Toolbar>
        </AppBar>
        {userBusy ? (
          <div className={classes.loader}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <UserTable
              items={this.props.users}
              limit={this.state.limit}
              page={this.state.page}
              count={this.props.count}
              formatDate={this.props.formatDate}
              handleEdit={this.handleEdit}
              handleChange={this.handleChange}
              viewDetails={this.viewDetails}
              accountBaseUrl={this.props.accountBaseUrl}
              isViewOnly={isViewOnly}
            />
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userType: "ALL",
    count: _get(state, "userData.count", 0),
    users: _get(state, "userData.users", []),
    userBusy: _get(state, "userData.userBusy", false),
    accountBaseUrl: _get(state, "authData.accountBaseUrl"),
    isAdmin: !!_get(state, "authData.profile.adminId"),
    isViewOnly: _get(state, "authData.isViewOnly", false),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUsers,
      getUserCount,
      selectedUser,
      getScopes,
      formatDate,
      updateUserScope,
    },
    dispatch
  );

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(User)
);
